import { CALL_API } from 'containers/App/screens/Tube/utils/oldApi';
import { url } from 'configs';

const { NEWTUBE_API_SERVER } = url;

const path = 'tube/preferenceSettings';

const PUT_PREFERENCE_SETTING_REQUEST = `${path}PUT_PREFERENCE_SETTING_REQUEST`;
const PUT_PREFERENCE_SETTING_SUCCESS = `${path}PUT_PREFERENCE_SETTING_SUCCESS`;
const PUT_PREFERENCE_SETTING_FAILURE = `${path}PUT_PREFERENCE_SETTING_FAILURE`;

export function putPreferenceSetting(data) {
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}User/Preferences`,
      method: 'PUT',
      types: [
        PUT_PREFERENCE_SETTING_REQUEST,
        PUT_PREFERENCE_SETTING_SUCCESS,
        PUT_PREFERENCE_SETTING_FAILURE,
      ],
      params: data,
    },
  };
}



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/containers/App/screens/Tube/screens/PreferenceSettings/reducers/index.js
 **/